import { useCallback } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  requestReportAction,
  Variables,
  ResponseStatus,
} from 'data/requests/reportActions';
import { CDError } from 'utils/error';
import { useSnackbar } from 'notistack';

const useReport = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryCache = useQueryClient();

  const { mutateAsync: requestReportMutation, isLoading } = useMutation<
    ResponseStatus,
    CDError,
    Variables
  >(requestReportAction);

  const requestReport = useCallback(
    async ({ reportType, dateStart, dateEnd }: Variables) => {
      try {
        await requestReportMutation({
          reportType,
          dateStart,
          dateEnd,
        });
        enqueueSnackbar(`Report request was created`, {
          variant: 'success',
        });
        queryCache.refetchQueries(['ReportHistory']);
        return {};
      } catch (error) {
        // @ts-ignore
        enqueueSnackbar(error.message || 'Failed to create report request', {
          variant: 'error',
        });
        return error;
      }
    },
    [requestReportMutation, enqueueSnackbar, queryCache],
  );

  return {
    isLoading,
    requestReport,
  };
};

export default useReport;
